import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import { setAddress } from '../../modules/signupEdit/actions'
import filterOffers from './filterOffers'

export default function* advanceToOffer() {
  const state = yield effects.select()
  const address = state.signupEdit.getIn(['edit', 'address'])

  const trimmed = address.trim()
  if (trimmed !== address) {
    yield effects.put.resolve(setAddress(trimmed))
  }

  yield effects.put.resolve(pushPath('/offer'))
  yield effects.call(filterOffers)

  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/advanceToOffer.js